import { sha256 } from 'js-sha256';

export const hashSHA256 = (value) => sha256(value);

export const hashValueIfExists = (value) => {
  if (!value) {
    return undefined;
  }
  return hashSHA256(value);
};
